export const CITY_FILTER = 'CITY_FILTER';
export const CATEGORY_FILTER = 'CATEGORY_FILTER';
export const DROP_FILTER_OPEN = 'DROP_FILTER_OPEN';

export const COUNTY_LIST_RETRIEVE = 'COUNTY_LIST_RETRIEVE';
export const SET_WHERE_FILTER = 'SET_WHERE_FILTER';
export const SET_KIND_FILTER = 'SET_KIND_FILTER';
export const SET_DATE_FILTER = 'SET_DATE_FILTER';
export const SET_KEYWORD_FILTER = 'SET_KEYWORD_FILTER';
export const SET_NEW_LIMIT = 'SET_NEW_LIMIT';
export const SEARCH_SUGGESTIONS = 'SEARCH_SUGGESTIONS';

export const FILTERED_EVENTS_RETRIEVED = 'FILTERED_EVENTS_RETRIEVED';
export const SINGLE_EVENT_RETRIEVED = 'SINGLE_EVENT_RETRIEVED';
export const PROMOTED_EVENTS_RETRIEVED = 'PROMOTED_EVENTS_RETRIEVED';
export const FESTIVAL_EVENT_RETRIEVED = 'FESTIVAL_EVENT_RETRIEVED';

export const START_FILTERED_LOAD = 'START_FILTERED_LOAD';
export const END_FILTERED_LOAD = 'END_FILTERED_LOAD';
export const TOTAL_EVENTS = 'TOTAL_EVENTS';

export const PLACE_RETRIEVED = 'PLACE_RETRIEVED';

export const BANNERS = 'BANNERS';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const LOGGED_IN_STATUS = 'LOGGED_IN_STATUS';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const PROFILE_FETCHED = 'PROFILE_FETCHED';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const TOGGLE_MODAL_TYPE = 'TOGGLE_MODAL_TYPE';
export const RESET_LINK_SENT = 'RESET_LINK_SENT';
export const STATIC_PAGE_RETRIEVED = 'STATIC_PAGE_RETRIEVED';
export const PILETILEVI_TOP = 'PILETILEVI_TOP';
export const RECENT_EVENTS = 'RECENT_EVENTS';
export const SET_ALL_FILTERS = 'SET_ALL_FILTERS';
export const SET_TEMP_DATA = 'SET_TEMP_DATA';

